import qs from 'qs';
import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import Heading from './components/heading';
import request from '../../request';
import StudiesContainer from '../shared/studies';

const titles = {
  pending: 'Pending Studies',
  progress: 'In Progress Studies',
  scored: 'Archived Studies',
};

export default class Pending extends React.Component {
  static contextTypes = {
    router: PropTypes.object.isRequired,
  };

  constructor({ match }) {
    super();
    this.state = {
      studies: JSON.parse(
        localStorage.getItem('type-' + match.params.type)
      ) || { data: [] },
    };
  }

  componentDidMount() {
    this.load();
  }

  componentDidUpdate(nextProps) {
    if (nextProps.location !== this.props.location) this.load();
  }

  async load() {
    let { match, location } = this.props;
    let query = qs.parse(location.search.substring(1));
    let page = query.page || 1;
    let url = `studies?types=${match.params.type}&page=${page}`;
    if (query.search !== undefined)
      url = `studies/search?search=${query.search ||
        ''}&page=${page}${query.company
        ? `&company=${query.company}`
        : ''}${query.start_date
        ? `&start_date=${query.start_date}`
        : ''}${query.end_date ? `&end_date=${query.end_date}` : ''}`;

    try {
      this.setState({ loading: true });
      let studies = await request({ url });
      localStorage.setItem(
        'type-' + match.params.type,
        JSON.stringify(studies)
      );
      this.setState({ studies, loading: false });
    } catch (e) {
      console.error(e);
      this.setState({ loading: false });
    }
  }

  render() {
    let { match, location } = this.props;
    let query = qs.parse(location.search.substring(1));
    let { studies, loading } = this.state;
    let page = parseInt(query.page || 1, 10);
    return (
      <div id="dashboard" style={{ opacity: loading ? 0.5 : 1 }}>
        <Heading
          onSearch={value =>
            this.context.router.history.push(`/types?search=${value}`)}
          search={query.search}
          title={
            titles[match.params.type] ||
            `Search${query.search ? ` for '${query.search}'` : ''}`
          }
        />
        {studies.data
          ? <StudiesContainer
              studies={studies.data}
              archived={true}
              search={query.search || query.company}
            />
          : null}

        {studies.prev_page_url
          ? <Link
              className="prev-button"
              to={
                query.search
                  ? `/types?${qs.stringify({
                      ...query,
                      page: page - 1,
                    })}`
                  : `/types/${match.params.type || ''}?${qs.stringify({
                      ...query,
                      page: page - 1,
                    })}`
              }
            >
              Previous Page
            </Link>
          : null}

        {studies.next_page_url
          ? <Link
              className="next-button"
              to={
                query.search
                  ? `/types?${qs.stringify({
                      ...query,
                      page: page + 1,
                    })}`
                  : `/types/${match.params.type || ''}?${qs.stringify({
                      ...query,
                      page: page + 1,
                    })}`
              }
            >
              Next Page
            </Link>
          : null}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/dashboard/types.js